// extracted by mini-css-extract-plugin
var _1 = "BirdviewAttentionRowAgeSelect-moduledropdown__azOzO FloatingSelectDropdown-moduledropdown__O8nBT";
export { _1 as "dropdown" }
